@if (
  pageInfo?.["title"] != "Analytical" && pageInfo?.["title"] != "eCommerce"
) {
  <div
    class="rounded p-y-30 p-x-24 m-b-30 overflow-hidden"
    style="background-color: rgba(198, 203, 142, 0.3)"
  >
    <div class="row">
      <div class="col-sm-8">
        <h4
          class="page-title m-0 f-s-24 f-w-600 m-b-16"
          style="color: rgba(19, 43, 23, 1) !important"
        >
          {{ pageInfo?.["title"] }}
        </h4>
        <div *ngIf="pageInfo?.urls && pageInfo.urls.length">
          <!-- Aquí va tu código para mostrar breadcrumbs -->
          <ul class="breadcrumb">
            <li
              *ngFor="let url of pageInfo.urls; let i = index"
              class="breadcrumb-item"
            >
              <ng-container *ngIf="i === 0; else lastBreadcrumb">
                <a [routerLink]="url.url">{{ url.title }}</a>
              </ng-container>
              <ng-template #lastBreadcrumb>
                <div style="display: flex; align-items: start; gap: 6px;">
                  <i-tabler
                    name="circle-filled"
                    class="icon-8"
                    style="padding: 0 2px;"
                  ></i-tabler>
                  <span>{{ url.title }}</span>
                </div>
              </ng-template>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-4 text-right position-relative">
        <div class="breadcrumb-icon">
          <img
            src="/assets/images/breadcrumb/piggy-bank.svg"
            alt="breadcrumb"
            width="120"
          />
        </div>
      </div>
    </div>
  </div>
}
